import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export async function requestAccountDeletion() {
  const result = await httpsCallable(functions, "requestAccountDeletion")({});
  return result.data;
}
